import React, { useState, useEffect } from "react";
import AuthDialog from "../auth/AuthDialog";
import fitnessAgeImage from "../../assets/images/FitnessAgeImage.png";
import fitness_age1 from "../../assets/images/fitness_age1.png";
// import fitnessSideImage from "../../assets/images/fitnessLeftSide.png";
import cardioHealth from "../../assets/images/cardioHealthImg.png";
// import healthyLife from "../../assets/images/healthy_life.png";
import Fade from "react-reveal/Fade";
// import ic_tick from "../../assets/icons/ic_check.svg";
import { HealthyLife } from "../discovery/LandingPage";
// import useIsMobile from "../../utils/useIsMobile";
import headerImage from "../../assets/images/HeaderImage.png";
import { useNavigate } from "react-router-dom";
import { QuickStretches } from "./QuickStretches";
import IconButton from "../basic/IconButton";
import ic_close from "../../assets/icons/ic_close.svg";
import { Dialog, Transition } from "@headlessui/react";
import CustomDialog from "../basic/Dialog";
import InstructionDialog from "../home/InstructionDialog";

// Sub-Header
export function Header({ openAuth }) {
  const Indicator = ({ text, showLine, number }) => (
    <div className={`flex flex-col w-full `}>
      <div className="flex flex-row w-full items-center">
        <div
          className={`flex items-center justify-center rounded-full h-[60px] w-[60px] p-1 bg-white bg-opacity-5 `}
        >
          <div
            className={`flex items-center justify-center text-white text-lg md:text-xl font-bold leading-relaxed rounded-full h-[40px] w-[40px] p-1 shadow-xl bg-white bg-opacity-5 `}
          >
            {number}
          </div>
        </div>
        {showLine && (
          <div className="lg:w-40 w-[60px] flex-1 bg-customGray-100 h-[2px] bg-opacity-50 rounded-md flex items-center "></div>
        )}
      </div>
      <p className={`font-open-sans font-bold text-white md:text-xl `}>
        {text}
      </p>
    </div>
  );
  return (
    <div
      style={{ backgroundImage: `url(${headerImage})` }}
      className=" w-full bg-no-repeat bg-cover bg-center"
    >
      <Fade up duration={700}>
        <div className="flex flex-col md:flex-row space-y-5 md:space-y-0 px-5 md:px-32 py-4 md:py-10 ">
          <div className="flex flex-1 flex-col">
            <p className="font-poppins text-white font-bold text-3xl md:text-5xl leading-snug">
              Know Your{" "}
              <span className="text-primary-neonGreen">
                Body Better
                {/* <span className="text-white">for free.</span> */}
              </span>
            </p>
          </div>
          <div className="flex flex-row justify-between">
            <Indicator
              className="text-xl font-medium"
              showLine
              text="Select"
              number={1}
            />
            <Indicator
              className="text-xl font-medium"
              showLine
              text="Perform"
              number={2}
            />
            <Indicator
              className="text-xl font-medium"
              text="Get results"
              number={3}
            />
          </div>
        </div>
      </Fade>
    </div>
  );
}

// Fitness-Feature
// export function FitnessAgeFeature({ openAuth }) {
//   const isMobile = useIsMobile();
//   return (
//     <div className="w-full px-5 md:px-32 pt-10">
//       <Fade up duration={700}>
//         <div className="relative flex flex-row overflow-clip bg-[#0B0F19] rounded-lg w-full">
//           <div className="absolute top-0 md:left-16 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
//           <div className="absolute -bottom-20 -right-10 md:right-0 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
//           <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 items-center rounded-lg px-5 md:px-28 py-8 md:py-20 backdrop-blur-3xl w-full">
//             <div className="flex flex-1 flex-col w-full">
//               <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
//                 <span className="text-primary-neonGreen">Fitness </span>
//                 <br></br>
//                 Age Test
//               </p>
//             </div>
//             <div className="space-y-1">
//               {[
//                 "An indicator of your strength, mobility and cardio capacity.",
//                 "Helps identifying your improvement areas.",
//                 "Recommended exercises, routines, programs to improve your fitness",
//               ].map((text) => {
//                 return (
//                   <p className="font-open-sans leading-8 flex flex-row  text-white text-opacity-70">
//                     <span className="mt-1 mr-2">
//                       <img src={ic_tick} />
//                     </span>
//                     <span className="flex flex-1">{text}</span>
//                   </p>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </Fade>
//     </div>
//   );
// }

// Cardio-Feature
// export function CardioHealthFeature({ openAuth }) {
//   const isMobile = useIsMobile();
//   return (
//     <div className="w-full px-5 md:px-32 pt-10">
//       <Fade up duration={700}>
//         <div className="relative flex flex-row overflow-clip bg-[#0B0F19] rounded-lg w-full">
//           <div className="absolute top-0 md:left-16 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
//           <div className="absolute -bottom-20 -right-10 md:right-0 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
//           <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 items-center rounded-lg px-5 md:px-28 py-8 md:py-20 backdrop-blur-3xl w-full">
//             <div className="flex flex-1 flex-col w-full">
//               <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
//                 <span className="text-primary-neonGreen">Cardio </span>
//                 <br></br>
//                 Health Test
//               </p>
//             </div>
//             <div className="space-y-1">
//               {[
//                 "An indicator of your cardiovascular health, stamina and body recovery level.",
//                 "Helps identify improvement areas.",
//                 "Recommends verified workouts and plans to strengthen your heart.",
//               ].map((text) => {
//                 return (
//                   <p className="font-open-sans leading-8 flex flex-row  text-white text-opacity-70">
//                     <span className="mt-1 mr-2">
//                       <img src={ic_tick} />
//                     </span>
//                     <span className="flex flex-1">{text}</span>
//                   </p>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </Fade>
//     </div>
//   );
// }

// Warning Pop-up FitnessAge
export function WarningPopUpAge({ open, close, onClickNext }) {
  const [showStartDialog, setShowStartDialog] = useState(false);
  console.log("warning popup 2");
  return (
    <>
  {       <InstructionDialog
        show={showStartDialog}
        close={() => {
          setShowStartDialog(false);
        }}
        allowDontShow={false}
        redirectUrl={onClickNext}
      /> }
      <CustomDialog show={open} close={close}>
        <Dialog.Panel className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />
            <p className="font-medium text-white  text-md py-4 mx">
              In case of any existing injuries and/or medical condition, kindly
              consult with a certified doctor before starting this evaluation.
            </p>
            <div className="flex justify-center items-center">
              <button
                // className="font-poppins md:text-xl text-md font- md:px-6 md:py-3 rounded-md bg-primary-neonGreen text-[#000000]"
                className="max-w-max mt-5 text-[#000000] cursor-pointer text-sm font-medium rounded-md bg-primary-neonGreen px-8 py-3"
                onClick={() => {
                  // onClickNext();
                  setShowStartDialog(true);
                }}
              >
                Next
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true} className="bg-[#1A1B22]">
        <Transition.Child
          // as={Fragment}
          enter="transform transition ease-in-out duration-300"
          leave="transform transition ease-in-out duration-300"
        ></Transition.Child>
      </Transition>
    </>
  );
}

// Warning Pop-Up CardioHealth
export function WarningPopUpCardio({ open, close, onClickNext }) {
  const [showStartDialog, setShowStartDialog] = useState(false);
  console.log("warning popup 2");
  return (
    <>
      <InstructionDialog
        show={showStartDialog}
        close={() => {
          setShowStartDialog(false);
        }}
        allowDontShow={false}
        redirectUrl={onClickNext}
      />
      <CustomDialog show={open} close={close}>
        <Dialog.Panel className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />
            <p className="font-medium text-white  text-md py-4 mx">
              In case of any existing injuries and/or medical condition, kindly
              consult with a certified doctor before starting this evaluation.
            </p>
            <div className="flex justify-center items-center">
              <button
                // className="font-poppins md:text-xl text-md font- md:px-6 md:py-3 rounded-md bg-primary-neonGreen text-[#000000]"
                className="max-w-max mt-5 text-[#000000] cursor-pointer text-sm font-medium rounded-md bg-primary-neonGreen px-8 py-3"
                onClick={() => {
                  setShowStartDialog(true);
                }}
              >
                Next
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true} className="bg-[#1A1B22]">
        <Transition.Child
          // as={Fragment}
          enter="transform transition ease-in-out duration-300"
          leave="transform transition ease-in-out duration-300"
        ></Transition.Child>
      </Transition>
    </>
  );
}

const Wellness = () => {
  const [showAuth, setShowAuth] = useState(false);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [dob, setDob] = useState();
  const [mobile, setMobile] = useState();
  const [fitnessageURL, setFitnessageURL] = useState("");
  const [cardioHealthURL, setCardioHealthURL] = useState();
  const [openFitnessAgeWarning, setOpenFitnessAgeWarning] = useState(false);
  const [openCardioHealthWarning, setOpenCardioHealthWarning] = useState(false);

  const navigate = useNavigate();

  const setURLS = () => {
    const baseURL = window.location.href;
    let url = new URL(baseURL);
    let search_params = url.searchParams;
    const fn = search_params.get("firstName");
    const ln = search_params.get("lastName");
    const mobile = search_params.get("mobile");
    const dob = search_params.get("dob");

    if (fn == null || ln == null || mobile == null || dob == null) {
      navigate("/");
    }

    setFirstName(search_params.get("firstName"));
    setLastName(search_params.get("lastName"));
    setDob(search_params.get("dob"));
    setMobile(search_params.get("mobile"));
    const u =
      "https://app.getactyvphysio.com/fitnessage?first_name=" +
      fn +
      "&last_name=" +
      ln +
      "&mobile=" +
      mobile +
      "&dob=" +
      dob;
    console.log(u);
    setFitnessageURL(u);
    const cardioHealthURL =
      "https://app.getactyvphysio.com/cardiohealth?first_name=" +
      fn +
      "&last_name=" +
      ln +
      "&mobile=" +
      mobile +
      "&dob=" +
      dob;
    setCardioHealthURL(cardioHealthURL);
    console.log(fitnessageURL);
  };

  useEffect(() => {
    setURLS();
  }, []);

  // set to localStorage
  // localStorage.setItem("name", firstName + " " + lastName);
  // localStorage.setItem("mobile", mobile);
  // localStorage.setItem("dob", "dob");

  // const { search } = useLocation();
  // const params = new URLSearchParams(search);
  // const first_Name = params.get("firstName");
  // const last_Name = params.get("lastName");
  // const mobileNumber = params.get("mobile");
  // const userDob = params.get("dob");
  // console.log("url datas : " + first_Name);
  return (
    <>
      <AuthDialog open={showAuth} setOpen={setShowAuth} />
      <WarningPopUpAge
        open={openFitnessAgeWarning}
        close={() => {
          setOpenFitnessAgeWarning(false);
        }}
        onClickNext={fitnessageURL}
      />
      <WarningPopUpCardio
        open={openCardioHealthWarning}
        close={() => {
          setOpenCardioHealthWarning(false);
        }}
        onClickNext={cardioHealthURL}
      />

      <div className="bg-[#0E0E11]">
        <Header
          openAuth={() => {
            setShowAuth(true);
          }}
        />

        {/* Fitness Age */}
        {/* <div className="w-full px-5 md:px-32 pt-10">
          <div className="lg:flex-row flex-col">
            <div
              style={{
                backgroundImage: `url(${fitness_age1})`,
                backgroundSize: "cover",
              }}
              className="lg:px-10 lg:py-3 px-8 pb-4"
            >
              <div
                className="flex md:flex-row flex-col"
              >
                <div className="lg:-mb-3 md:-mb-3 sm:mb-0 flex justify-center ">
                  <img src={fitnessAgeImage} alt="image is loading" />
                </div>
                <div className="grid grid-rows-2 lg:gap-4 xl:gap-16 gap-2 lg:col-span-2 lg:px-40 px-0 align-middle">
                  <p className="md:text-3xl text-xl font-bold text-white font-poppin md:pt-10 pt-6">
                3 Quick{" "}
                    <span className="text-primary-neonGreen">Exercises</span>
                    <br />
                    <p className="text-white">in under 5 minutes</p>
                  </p>
                  <p className="md:text-lg text-sm text-[#757798] lg:pt-6 pt-3 lg:pb-0 pb-10 ">
                    Fill in a simple form and perform three <br />
                    quick exercises to find out your Fitness Age.
                  </p>
                </div>
                <div className="grid grid-rows-2 sm:grid-rows-1 lg:gap-20 xl:gap-24 md:gap-16 px-10">
                  <div className="hidden lg:block"></div>
                  <div className="flex justify-center sm:py-12">
                    <button
                      className="lg:px-16 lg:py-3 px-8 py-2 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium"
                      onClick={() => {
                        setOpenFitnessAgeWarning(true);
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* Fitness Age */}
        <div className="w-full px-5 md:px-32 pt-10 md:mt-0 mt-10 rounded-xl hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500">
          <div className="lg:flex-row flex-col">
            <div
              style={{
                backgroundImage: `url(${fitness_age1})`,
                backgroundSize: "cover",
              }}
              // className="px-10 py-3  mx-20 my-16"
              // className="lg:px-10 lg:py-3 px-8 lg:pt-6 pb-0 overflow-hidden"
            >
              <div
                // className="grid grid-cols-4 w-full"
                className="flex md:flex-row flex-col"
              >
                <div
                  // className="grid grid-rows-2 lg:gap-2 xl:gap-12 gap-0 col-span-2"
                  className="grid grid-rows-2 gap-2 lg:col-span-2"
                >
                  <p
                    // className="text-3xl font-bold text-white font-poppin pt-10"
                    className="md:text-2xl text-xl font-bold text-white font-poppin pt-10 px-10"
                  >
                    {/* <span className="text-primary-neonGreen">
                      Exercises
                    </span>  */}
                    Find out your{" "}
                    <span className="text-primary-neonGreen">Fitness age</span>
                    <br />
                    {/* <p className="text-white">in under 5 minutes</p> */}
                    <p className="text-white">within 5 mins with 3 exercises</p>
                  </p>
                  <p
                    // className="text-md text-[#757798]  pt-10"
                    className="md:text-lg text-sm text-white lg:pt-10 pt-3 lg:pb-0 pb-10 px-10"
                  >
                    {/* Fill in a simple form and perform four <br />
                    quick exercises to find out your Cardio Health. */}
                    An indicator of your strength, mobility and cardio capacity
                  </p>
                </div>
                <div
                  // className="grid md:grid-rows-2 sm:grid-rows-1 lg:gap-20 xl:gap-24 gap-16 pr-10"
                  className="grid grid-rows-2 sm:grid-rows-1 lg:px-10 px-0"
                >
                  <div className="hidden lg:block"></div>
                  <div
                    // className="flex justify-end py-6"
                    className="flex justify-center lg:pb-16"
                  >
                    <button
                      // className="px-16 py-3 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium"
                      className="lg:px-12 lg:py-3 px-8 py-2 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
                      onClick={() => {
                        // window.location.href = cardioHealthURL;
                        // setOpenCardioHealthWarning(true);
                        // setTestType("fitness_age");
                        setOpenFitnessAgeWarning(true);
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
                <div
                  // className="grid align-bottom -mb-5"
                  className="lg:pt-8 -pt-60  pb-0 flex lg:justify-end justify-center lg:ml-24  h-full"
                >
                  <img src={fitnessAgeImage} alt="image is loading" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <FitnessAgeFeature
          openAuth={() => {
            setShowAuth(true);
          }}
        /> */}

        {/* Cardio Health */}
        {/* <div className="w-full px-5 md:px-32 pt-10">
          <div className="lg:flex-row flex-col">
            <div
              style={{
                backgroundImage: `url(${fitness_age1})`,
                backgroundSize: "cover",
              }}
            >
              <div
                className="flex md:flex-row flex-col"
              >
                <div
                  className="grid grid-rows-2 gap-2 lg:col-span-2"
                >
                  <p
                    className="md:text-3xl text-xl font-bold text-white font-poppin pt-10 px-10"
                  >4 Quick{" "}
                    <span className="text-primary-neonGreen">
                      Exercises
                    </span>
                    <br />
                    <p className="text-white">in under 5 minutes</p>
                  </p>
                  <p
                    className="md:text-lg text-sm text-[#757798] lg:pt-10 pt-3 lg:pb-0 pb-10 px-10"
                  >
                    Fill in a simple form and perform four <br />
                    quick exercises to find out your Cardio Health.
                  </p>
                </div>
                <div
                  className="grid grid-rows-2 sm:grid-rows-1 lg:px-28 px-0"
                >
                  <div className="hidden lg:block"></div>
                  <div
                    className="flex justify-center pb-2 lg:pb-16"
                  >
                    <button
                      className="lg:px-16 lg:py-3 px-8 py-2 rounded-lg bg-primary-neonGreen text-[#000000] text-sm sm:text-md font-medium"
                      onClick={() => {
                        setOpenCardioHealthWarning(true);
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
                <div
                  className="lg:pt-8 -pt-12  pb-0 flex lg:justify-end justify-center lg:ml-28  h-full"
                >
                  <img src={cardioHealth} alt="image is loading" />
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Cardio Health */}
        <div className="w-full px-5 md:px-32 pt-10 md:mt-0 mt-2 rounded-xl hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500">
          <div className="lg:flex-row flex-col">
            <div
              style={{
                backgroundImage: `url(${fitness_age1})`,
                backgroundSize: "cover",
              }}
              // className="px-10 py-3  mx-20 my-16"
              // className="lg:px-10 lg:py-3 px-8 lg:pt-6 pb-0 overflow-hidden"
            >
              <div
                // className="grid grid-cols-4 w-full"
                className="flex md:flex-row flex-col"
              >
                <div
                  // className="grid grid-rows-2 lg:gap-2 xl:gap-12 gap-0 col-span-2"
                  className="grid grid-rows-2 gap-2 lg:col-span-2"
                >
                  <p
                    // className="text-3xl font-bold text-white font-poppin pt-10"
                    className="md:text-2xl text-xl font-bold text-white font-poppin pt-10 px-10"
                  >
                    {/* <span className="text-primary-neonGreen">
                      Exercises
                    </span>  */}
                    Find out your{" "}
                    <span className="text-primary-neonGreen">
                      Cardio health
                    </span>
                    <br />
                    {/* <p className="text-white">in under 5 minutes</p> */}
                    <p className="text-white">within 5 mins with 4 exercises</p>
                  </p>
                  <p
                    // className="text-md text-[#757798]  pt-10"
                    className="md:text-lg text-sm text-white lg:pt-10 pt-3 lg:pb-0 pb-10 px-10"
                  >
                    {/* Fill in a simple form and perform four <br />
                    quick exercises to find out your Cardio Health. */}
                    An indicator of your cardiovascular health, stamina and
                    <br /> body recovery level
                  </p>
                </div>
                <div
                  // className="grid md:grid-rows-2 sm:grid-rows-1 lg:gap-20 xl:gap-24 gap-16 pr-10"
                  className="grid grid-rows-2 sm:grid-rows-1 lg:px-10 px-0"
                >
                  <div className="hidden lg:block"></div>
                  <div
                    // className="flex justify-end py-6"
                    className="flex justify-center pb-2 lg:pb-16 lg:pr-4 lg:pl-6"
                  >
                    <button
                      // className="px-16 py-3 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium"
                      className="lg:px-12 lg:py-3 px-8 py-2 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
                      onClick={() => {
                        // window.location.href = cardioHealthURL;
                        // setOpenCardioHealthWarning(true);
                        // setTestType("cardiohealth");
                        setOpenCardioHealthWarning(true);
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
                <div
                  // className="grid align-bottom -mb-5"
                  className="lg:pt-8 -pt-12  pb-0 flex lg:justify-end justify-center lg:ml-24  h-full"
                >
                  <img src={cardioHealth} alt="image is loading" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <CardioHealthFeature
          openAuth={() => {
            setShowAuth(true);
          }}
        /> */}

        <QuickStretches />

        {/* <div
        className="w-full h-full"
        style={{
          backgroundImage: `url(${fitnessSideImage})`,
          backgroundSize: "cover",
        }}
      >
        Hello
      </div> */}

        {/* <FitnessAgeFeature
          openAuth={() => {
            setShowAuth(true);
          }}
        /> */}

        <HealthyLife
          openAuth={() => {
            setShowAuth(true);
          }}
        />
      </div>
    </>
  );
};

export default Wellness;
